import { isLimitedTimeOffer } from './is-limited-time-offer';
import { isNew } from './is-new';

/**
 * Generates offer text for inventory data.
 *
 * @param {Object} inventory Inventory data
 * @returns {String} Inventory offer text.
 */
export function getOfferText(inventory) {
  const prices = inventory.prices;
  if (!prices) {
    return '';
  }
  const isNewVin = isNew(inventory.type);
  const guaranteedPrice = !!(
    prices.displayPrice &&
    prices.guaranteedPrice &&
    prices.guaranteedPrice < prices.displayPrice
  );
  const limitedTimeOffer = isLimitedTimeOffer(inventory);

  if (guaranteedPrice && isNewVin) {
    return limitedTimeOffer ? 'Limited Time Offer' : 'Special Offer Available';
  }
  return '';
}
